import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

const CollapsibleSection = ({
  icon: Icon,
  title,
  children,
  defaultOpen = true,
}: {
  icon: React.FC<{ className?: string }>;
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-border rounded-lg">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full p-4"
      >
        <div className="flex items-center gap-2">
          <div className="p-1.5 rounded-lg bg-accent-light">
            <Icon className="h-4 w-4 text-accent" />
          </div>
          <h4 className="font-semibold text-card-foreground">{title}</h4>
        </div>
        <ChevronDown
          className={cn(
            "h-4 w-4 text-muted-foreground transition-transform",
            isOpen && "rotate-180"
          )}
        />
      </button>
      {isOpen && <div className="px-5 pb-5">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
